import { useFormContext } from 'react-hook-form';

import Card from '../../../components/Card';
import Input from '../../../components/form/Input';

const BookCoverWithBannerSectionDetailPresenter = () => {
  const { register, watch } = useFormContext();
  const [bookCoverWithBannerImageUrl, dayBgImageUrl, darkBgImageUrl] = watch(['imageUrl', 'dayBgImageUrl', 'darkBgImageUrl']);

  return (
    <Card className="space-y-16">
      <div className="text-22">Book Cover With Banner Detail</div>
      <div className="grid grid-cols-1 lg:grid-cols-[minmax(360px,1fr)_292px] gap-16 items-start lg:items-stretch">
        <div className="flex flex-col gap-12 lg:h-[519px]">
          <Input label="Banner Image URL" name="imageUrl" placeholder="https://banner-image.png" register={register} required helperText="แนะนำขนาด 292x519 px" />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 lg:flex-1 lg:min-h-0">
            <div className="flex flex-col gap-8 lg:min-h-0">
              <Input label="Day Background Image URL" name="dayBgImageUrl" placeholder="https://day-bg-image.png" register={register} required />
              <div className="flex items-center justify-center w-full h-[180px] lg:h-auto lg:flex-1 rounded-[6px] border border-dashed overflow-hidden bg-[#FFEAEA]">
                {dayBgImageUrl ? (
                  <img src={dayBgImageUrl} alt="Day Background Preview" className="w-full h-full object-cover" />
                ) : (
                  <p className="px-8 text-center text-12 text-colorsBrandRed01Primary font-semibold">Day BG Preview</p>
                )}
              </div>
            </div>

            <div className="flex flex-col gap-8 lg:min-h-0">
              <Input label="Dark Background Image URL" name="darkBgImageUrl" placeholder="https://dark-bg-image.png" register={register} required />
              <div className="flex items-center justify-center w-full h-[180px] lg:h-auto lg:flex-1 rounded-[6px] border border-dashed overflow-hidden bg-[#FFEAEA]">
                {darkBgImageUrl ? (
                  <img src={darkBgImageUrl} alt="Dark Background Preview" className="w-full h-full object-cover" />
                ) : (
                  <p className="px-8 text-center text-12 text-colorsBrandRed01Primary font-semibold">Dark BG Preview</p>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-center w-[292px] h-[519px] rounded-[6px] border border-dashed overflow-hidden" style={{ backgroundColor: '#FFEAEA' }}>
          {bookCoverWithBannerImageUrl ? (
            <img src={bookCoverWithBannerImageUrl} alt="Banner Preview" className="w-[292px] h-[519px] object-cover" />
          ) : (
            <p className="px-16 text-center text-colorsBrandRed01Primary font-semibold">ไฟล์ PNG (9:16) : 292 x 519 px</p>
          )}
        </div>
      </div>
    </Card>
  );
};

export default BookCoverWithBannerSectionDetailPresenter;
